import React from 'react';
import { Rect, Text } from 'react-konva';
import {
  isMobilePhone,
  isMobileTablet,
} from '../../library/calc';

export const ConfirmButton = ({ fn,
    n,
    g,
    pid,
    left,
    top,
    focus,
    stopStageClickPropagation,
    p,
    nn,
    strokeWidth,
    bubbleBodyHeight,
    bubbleBodyWidth,
    yCoord4Bubble,
    leftBubble,
    cursorBecomesMove,
    cursorBecomesPointer,
    fill,
    confirmCallbackInToolTip,
    confirmLabelWidthInToolTip,
    buttonsLeft,
    buttonsTop,
    buttonsWidthAddedToDefaultButtonSize,
    userTouchedNode,
  }) => {

  left += leftBubble + buttonsLeft;
  top += yCoord4Bubble + buttonsTop;

  return <Rect
    x={left}
    y={top}
    width={confirmLabelWidthInToolTip + buttonsWidthAddedToDefaultButtonSize}
    height={6}
    cursor={"pointer"}
    fill="#1590FF"
    stroke="#1590FF"
    strokeWidth={.2}
    cornerRadius={1.5}

    onTouchStart={()=>{
      userTouchedNode({
        node: n,
        callback: ()=>{
          if(isMobileTablet()) {
            stopStageClickPropagation({fromWhere: 'confirmButtonRect'});
            confirmCallbackInToolTip();
            return;
          }
        },
        fromWhere: 'confirmButtonRect'});
    }}

    onClick={()=>{
      if(isMobilePhone() ) return;
      confirmCallbackInToolTip();
      stopStageClickPropagation({fromWhere: 'foo moo baz'});
    }}

    onMouseenter={()=>{
      cursorBecomesPointer();
    }}
    onMouseleave={()=>{
      cursorBecomesMove();
    }}
  />;
};



export const ConfirmText = ({ fn,
    n,
    g,
    pid,
    left,
    top,
    focus,
    stopStageClickPropagation,
    p,
    nn,
    strokeWidth,
    bubbleBodyHeight,
    bubbleBodyWidth,
    yCoord4Bubble,
    leftBubble,
    cursorBecomesMove,
    cursorBecomesPointer,
    fill,
    confirmCallbackInToolTip,
    confirmLabelInToolTip,
    confirmLabelWidthInToolTip,
    buttonsLeft,
    buttonsTop,
    buttonsPadding,
    buttonsLeftPadding,
    buttonsTopPadding,
    userTouchedNode,
  }) => {

  left += leftBubble + buttonsLeft + buttonsLeftPadding;
  top += yCoord4Bubble + buttonsTop + buttonsTopPadding;

  return <Text
    x={left}
    y={top}
    text={confirmLabelInToolTip}
    fontSize={3.5}
    fill={'white'}
    cursor={"pointer"}
    align={'left'}

    onTouchStart={()=>{
      userTouchedNode({
        node: n,
        callback: ()=>{
          if(isMobileTablet()) {
            stopStageClickPropagation({fromWhere: 'confirmButtonText'});
            confirmCallbackInToolTip();
            return;
          }
        },
        fromWhere: 'confirmButtonText'});
    }}

    onClick={()=>{
      if(isMobilePhone() ) return;
      confirmCallbackInToolTip();
      stopStageClickPropagation({fromWhere: 'foo moo baz'});
    }}

    onMouseenter={()=>{
      cursorBecomesPointer();
    }}
    onMouseleave={()=>{
      cursorBecomesMove();
    }}
  />;
};


